import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getSelectedChartTypeFromFilterStore } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FilterStoreHook } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import React, { useMemo } from 'react';
import { SegmentedControl } from 'apps/sigma2-ui/src/components/ui/SegmentedControl';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const ChartTypeSegmentedControl = ({
  store,
  feature,
  databaseRevisionId,
  databaseId,
  organizationId,
  setPrimaryFilters,
  focusArea,
  analysisName,
}: {
  store: FilterStoreHook;
  feature: FiltersFeatureName;
  organizationId: string;
  databaseRevisionId: string;
  databaseId: string;
  focusArea: FocusArea | null;
  analysisName: string | undefined;
  setPrimaryFilters: (params: {
    selections: PrimaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
}) => {
  const selectedOption = useMemo(
    () =>
      getSelectedChartTypeFromFilterStore({
        store,
        feature,
        organizationId,
        databaseRevisionId,
        databaseId,
        focusArea,
        analysisName,
      }),
    [
      store,
      feature,
      organizationId,
      databaseRevisionId,
      databaseId,
      focusArea,
      analysisName,
    ],
  );

  const language = useLanguage();

  return (
    <Box w="w-[250px]">
      <SegmentedControl
        options={[
          { id: 'bar', label: language.chartTypeControlBarLabel() },
          { id: 'line', label: language.chartTypeControlLineLabel() },
        ]}
        selectedOption={selectedOption ?? undefined}
        onChange={(optionId) => {
          const primaryFiltersSelections: PrimaryFilterSelection[] = [
            {
              primaryFilterKey: 'chartType',
              value: optionId,
            },
          ];

          setPrimaryFilters({ selections: primaryFiltersSelections });
        }}
      />
    </Box>
  );
};
